// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XHBq","toggle":"styles_toggle__3SB6t","preview":"styles_preview__1Fe3G"};